export const trainings = state => state.training.trainings

export const isFetching = state => state.training.isFetching
